import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Row, Col } from '@saucelabs/sl-component-grid';
import { IconCaretUp, IconWarning } from '@saucelabs/sl-component-icons';
import { Checkbox } from '@saucelabs/sl-component-form';

import Styles from './RegressionItem.styles';
import { parseMetricsValue } from './../utils';

const RegressionItem = ({
  getPerformanceURL,
  regressionData,
  isChecked,
  onCheckboxUpdate,
  regressionType,
}) => {
  const {
    metrics,
    url,
    order_index: orderIndex,
  } = regressionData;

  const regressionMetrics = Object.keys(metrics).filter((metric) => (
    metrics[metric].outlier.status &&
    metrics[metric].outlier.reason === regressionType
  ));

  const handleChange = ({ target: { checked } }) => {
    onCheckboxUpdate(orderIndex, checked);
  };

  return (
    <section className={Styles['regression-item-container']}>
      <Checkbox
        checked={isChecked}
        className={Styles['regression-checkbox']}
        onChange={handleChange}
      />
      <div className={Styles['regression-item']}>
        <div className={Styles['url-info']}>
          <IconWarning className={Styles['warning-icon']} />
          <label className={Styles['url-label']}>URL</label>
          <span className={Styles['url-value']}>{url}</span>
        </div>
        <div className={Styles.metrics}>
          <Row>
            {regressionMetrics.map((metric) => (
              <Col
                key={metric}
                sm={6}
                xs={12}
              >
                <span className={Styles['metric-name']}>{metric}</span>
                <span className={Styles['metric-value']}>
                  {parseMetricsValue(metrics[metric].real_value, metric)}
                </span>
              </Col>
            ))}
          </Row>
        </div>
        <span className={Styles['report-link-container']}>
          <Link
            className={Styles['report-link']}
            to={getPerformanceURL({ orderIndex }).reportPageURL}
          >
            <IconCaretUp />
          </Link>
        </span>
      </div>
    </section>
  );
};

RegressionItem.propTypes = {
  getPerformanceURL: PropTypes.func.isRequired,
  isChecked: PropTypes.bool,
  onCheckboxUpdate: PropTypes.func.isRequired,
  regressionData: PropTypes.object.isRequired,
  regressionType: PropTypes.string.isRequired,
};

RegressionItem.defaultProps = {
  isChecked: false,
};

export default RegressionItem;
